var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1174 15.838C14.9808 17.8013 12.1304 19 8.99997 19C5.86956 19 3.01911 17.8013 0.882568 15.838C2.33403 14.1591 5.42336 13 8.99997 13C12.5766 13 15.6659 14.1591 17.1174 15.838ZM14 5C14 7.76142 11.7614 10 8.99997 10C6.23855 10 3.99997 7.76142 3.99997 5C3.99997 2.23858 6.23855 0 8.99997 0C11.7614 0 14 2.23858 14 5Z",
    fill: "currentColor"
  })));
};
export default SvgAccount;